import { Skeleton } from '@/components/ui/skeleton'

export function IntentsLoadingState() {
  return (
    <div className="space-y-4" role="status" aria-label="Loading intents" aria-live="polite" data-testid="intents-loading">
      <div className="flex items-center gap-4">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-4 flex-1" />
        ))}
      </div>
      {Array.from({ length: 6 }).map((_, row) => (
        <div key={row} className="flex items-center gap-4 py-3">
          {Array.from({ length: 3 }).map((_, col) => (
            <Skeleton key={col} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  )
}
